export default "__VITE_ASSET__DJx5M7WW__"